// extracted by mini-css-extract-plugin
export default {"trustCenter":"SruXJvgGuiWMJF0YVbjk"};